import React from 'react';
import Link from 'next/link';
import { DateTime } from 'luxon';
import { routes } from 'env/routes';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { useMutation } from '@tanstack/react-query';
import { useBWTokenContext } from 'env/context/bwTokenContext';

const GymWaiverExpiringSoonNotice = withCustomComponent(
  'GymWaiverExpiringSoonNotice',
)(
  inject(
    'appStore',
    'authStore',
  )(
    withRouter(
      observer(({ authStore, componentName, router }) => {
        const { token, refetch, gymWaiverExpiryDate } = useBWTokenContext();
        const { t } = useTranslation();

        const mutation = useMutation({
          mutationFn: async () => {
            // 1. Save the flag to the backend
            await fetch(
              `auth/api/flags/${encodeURIComponent(authStore.customer?.Email)}/hideGymWaiverMessage`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  authorization: `Bearer ${token} `,
                },
                body: JSON.stringify({ value: true }),
              },
            );

            // 2. Refresh token via server endpoint (sets HttpOnly cookie)
            await fetch('/api/refreshBruntwoodToken', { method: 'POST' });

            // 3. Update in-memory state
            await refetch();
          },
        });
        const handleClose = (e) => {
          e.preventDefault();
          mutation.mutate();
        };

        if (mutation.isPending) {
          return (
            <div className="d-flex flex-row align-items-center p-6">
              Update your waiver at any time by going to Settings &gt; My
              Account &gt; Gym waiver
            </div>
          );
        }

        if (!gymWaiverExpiryDate) return null;

        const formattedExpiry =
          DateTime.fromISO(gymWaiverExpiryDate).toFormat('dd/MM/yyyy');

        return (
          <div className="d-flex flex-row align-items-center justify-content-center w-100">
            <div data-component-name={componentName}>
              {t(
                'Your gym waiver will expire on {{date}}. Click here to update your details to retain access to the gym and classes.',
                { date: formattedExpiry },
              )}
            </div>
            {router.pathname.indexOf(routes.gym_waiver) == -1 && (
              <div>
                <Link href={routes.gym_waiver} className="mx-20 btn btn-sm">
                  {t('Update now')}
                </Link>
              </div>
            )}
            <button className="clear-notices" onClick={handleClose}>
              <i className="icon-close"></i>
            </button>
          </div>
        );
      }),
    ),
  ),
);

export default GymWaiverExpiringSoonNotice;
